import { combineReducers } from 'redux';
import auth from '../features/auth/authSlice';

export default combineReducers({ auth });
